import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Japanese() {
  return (
    <ApiCommunityDirectoryPage
      community="Japanese"
      eyebrow="Japanese community guide"
      title="Japanese favorites, businesses, and local essentials in San Antonio."
      
      tags={["Japanese community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Japanese community guide?"
      modalIdPrefix="japanese-directory"
    />
  );
}
